import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { useSaleRoDetailModel } from "./saleRoDetailModel";
import { formatNum } from "@/utils/utils";
import { RouterParamType } from "@/model/navModel";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { addDesc, editDesc, lookDesc } = useSaleRoDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: "退货项数",
            value: formatNum(addDesc.itemNumAll) ?? 0,
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "退货数量",
            value: formatNum(addDesc.numAll) ?? 0,
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "退货总金额",
            value: formatNum(addDesc.totalAll) ?? 0,
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}